<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">ダッシュボード</a>
            </li>
            <router-link tag="li" :to="{ name: 'phones'}">
              <a>スマートフォン一覧</a>
            </router-link>
            <li class="active">スマートフォン編集</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>スマートフォン編集</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
          <div class="alert alert-danger" v-if="errorMessageLogs!==''">
            {{ errorMessageLogs }}
          </div>
          <div class="alert alert-success" id="success-alert">
            {{ message }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="form-group">
                <div class="col-md-offset-3 col-md-9"><span id="model_error" class="error_m"></span></div>
                <label class="col-sm-3 control-label no-padding-right" for="form-field-1">端末名</label>
                <div class="col-sm-9">
                  <input type="text" id="form-field-1" placeholder="モデル" class="col-xs-10 col-sm-6" disabled v-model="phoneInfor.model"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label no-padding-right iValid" for="form-field-1">ステータス</label>
                <div class="col-sm-9">
                  <input name="switch-field-1" id="model" class="ace ace-switch ace-switch-4" type="checkbox" v-model="phoneInfor.isValid"><span class="lbl"></span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label no-padding-right" for="form-field-1"></label>
                <div class="col-sm-9">
                  <router-link :to="{ name: 'phones'}" class="btn cancel_bottom">
                    キャンセル
                  </router-link>
                  <button class="btn btn-info save_group_bottom" type="button" @click="validateBeforeSubmit">
                    保存
                  </button>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      errorMessageLogs: '',
      phoneInfor: {
        phoneId: '',
        model: '',
        isValid: false
      },
      flag: 0,
      message: '',
      success: false,
      loading: false
    }
  },
  created () {
    var vm = this
    vm.getPhoneData()
  },
  methods: {
    validateBeforeSubmit () {
      this.flag = 0
      if (this.phoneInfor.model === null || this.phoneInfor.model === '') {
        $('#model_error').html('端末名は必須です。')
        $('#model').addClass('error')
        this.flag++
      } else {
        $('#model_error').html('')
        $('#model').removeClass('error')
        this.flag = 0
      }
      if (!this.phoneInfor.model.match(/^[a-zA-Z0-9.-]*$/)) {
        $('#model_error').html('端末名は、半角英数および記号[-(ハイフン)と.(ピリオド)]のみ利用可能です。')
        $('#model').addClass('error')
        this.flag++
      } else {
        $('#model_error').html('')
        $('#model').removeClass('error')
        this.flag = 0
      }
      if (this.flag === 0) {
        this.editInforPhone()
      }
    },
    getPhoneData () {
      var vm = this
      var data = this.$route.query
      this.$http.get(Config.PHONES_LIST_API + '?phoneId=' + encodeURIComponent(data.id))
        .then(response => {
          vm.phoneInfor.phoneId = response.body.phones[0].phoneId
          vm.phoneInfor.model = response.body.phones[0].model
          vm.phoneInfor.isValid = response.body.phones[0].isValid
        })
        .catch(error => {
          console.log(error)
        })
    },
    editInforPhone () {
      var vm = this
      vm.errorMessageLogs = ''
      vm.loading = true
      const Infor = {
        model: vm.phoneInfor.model,
        isValid: vm.phoneInfor.isValid
      }
      this.$http.put(Config.PHONES_LIST_API + '/' + encodeURIComponent(vm.phoneInfor.phoneId), Infor)
        .then(response => {
          this.loading = false
          this.message = Config.EDIT_PHONE_API_SUCCESS
          $('#success-alert').fadeTo(2000, 500).slideUp(500, function () {
            $('#success-alert').slideUp(500)
          })
        })
        .catch((error) => {
          this.loading = false
          switch (error.status) {
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'スマートフォンの編集権限がありません。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
        })
    }
  }
}
</script>
<style>
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    border-radius: 10px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/phone/PhoneEdit.vue